module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contactView"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "0",
      "width": "0"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-card', {
    attrs: {
      "id": "contactForm"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.isHcpView ? 'Further Information and Feedback' : _vm.$t('message.contactTitle'),
      "titleClass": "largeTitle boldTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.isHcpView) ? _c('reset-account') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitMessage.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.isHcpView ? 'Subject' : _vm.$t('message.contactSubTitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      staticClass: "radio-item"
    }, [_c('mu-radio', {
      key: 'platformOption-' + index,
      staticClass: "radio",
      attrs: {
        "label": option.label,
        "nativeValue": option.key
      },
      model: {
        value: (_vm.messageModel.platform),
        callback: function($$v) {
          _vm.$set(_vm.messageModel, "platform", $$v)
        },
        expression: "messageModel.platform"
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "mainTitle",
    domProps: {
      "textContent": _vm._s(_vm.isHcpView ? 'Your message' : _vm.$t('message.contactBodyLabel'))
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": _vm.isHcpView ? 'Enter your message here' : _vm.$t('message.placeholderText'),
      "multiLine": "",
      "rows": 5,
      "rowsMax": 6,
      "fullWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "message",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.contactBodyLabel'),
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('message')
    },
    model: {
      value: (_vm.messageModel.message),
      callback: function($$v) {
        _vm.$set(_vm.messageModel, "message", $$v)
      },
      expression: "messageModel.message"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('vue-recaptcha', {
    ref: "invisibleRecaptcha",
    attrs: {
      "sitekey": "6Lf_8LsUAAAAAPqMvImMQATwGHVXXM_Ke1oNLi-T",
      "size": "invisible"
    },
    on: {
      "verify": _vm.onVerify
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSending,
      "label": _vm.isSending ? _vm.$t('message.sendingText') : _vm.isHcpView ? 'Send' : _vm.$t('message.submitText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitMessage.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "0",
      "width": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2165bcd9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contact/Contact.vue
// module id = 3080
// module chunks = 1